import React from 'react';
import { Box, Typography, IconButton, Grid } from '@mui/material';
import {
  Chair,
  CircleOutlined,
  RectangleOutlined,
  SquareOutlined
} from '@mui/icons-material';

const IconSelector = ({ tipo, iconoSeleccionado, onIconSelect }) => {
  const iconosMesas = [
    /* { id: 'cuadrado', name: 'Cuadrado', component: SquareOutlined }, */
    { id: 'circulo', name: 'Circular', component: CircleOutlined },
    /* { id: 'rectangular', name: 'Rectangular', component: RectangleOutlined } */
  ];

  const iconosAsientos = [
    { id: 'circulo', name: 'Circular', component: CircleOutlined },
  ];

  const iconos = tipo === 'mesa' ? iconosMesas : iconosAsientos;

  return (
    <Box sx={{ mt:1, mb: 2 }}>
      <Typography variant="p" sx={{ mb: 2, color: "#0b0062" }}>Estilo visual </Typography>
      <Grid container spacing={1}>
        {iconos.map((icono) => (
          <Grid item xs={4} key={icono.id}>
            <IconButton
              onClick={() => onIconSelect(icono.id)}
              sx={{
                mt: 1,
                border: iconoSeleccionado === icono.id ? '2px solid #5656ff' : '1px solid #ddd',
                borderRadius: 1,
                width: '100%',
                height: 60,
                display: 'flex',
                flexDirection: 'column',
                fontSize: '12px'
              }}
            >
              {icono.component ?
                <icono.component fontSize="small" sx={{ color: iconoSeleccionado === icono.id ? '#5656ff' : ' #98989A', }} /> :
                <span style={{ fontSize: '20px', color: "#5656ff" }}>{icono.icon}</span>
              }
              <Typography variant="caption" sx={{ mt: 0.5, color: iconoSeleccionado === icono.id ? '#5656ff' : ' #98989A',}}>
              {icono.name}
            </Typography>
          </IconButton>
          </Grid>
        ))}
    </Grid>
    </Box >
  );
};

export default IconSelector;